export default [
	{
		path: '/states',
		name: 'states',
		component: () => import('@/views/State/States.vue'),
		meta: { requiresAuth: true, permission: 'view_states' }
	},
	{
		path: '/states/create',
		name: 'states.create',
		component: () => import('@/views/State/CreateState.vue'),
		meta: { requiresAuth: true, permission: 'create_state' }
	}
]
